import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { AdminService } from '../../../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';
import { DecisionsTransformService } from '../../../../../../../services/admin/decisions-transform.service';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent implements OnInit {
  decisions: any = null;
  constructor(
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _decisionsTransformService: DecisionsTransformService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.getDecisions();
  }
  closeDialog() {
    this.dialogRef.close();
  }
  getDecisions() {
    this._loadingService.register();
    this._adminService.getDecision(this.data.petition.id).subscribe(
      (res) => {
        this.decisions = res;
        this._loadingService.resolve();
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  getTitle(decision) {
    return this._decisionsTransformService.transform(
      decision.type,
      this.data.petition.petitionStatusId
    );
  }
  exportFile(fileId: string): void {
    this._adminService.openFilePdf(fileId);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/notification-dialog/notification-dialog.component.ts